export default "__VITE_ASSET__8ff67352__"